import { render } from "./BadgeKind.vue?vue&type=template&id=5d2e4ec8&scoped=true"
import script from "./BadgeKind.vue?vue&type=script&lang=js"
export * from "./BadgeKind.vue?vue&type=script&lang=js"

import "./BadgeKind.vue?vue&type=style&index=0&id=5d2e4ec8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2e4ec8"]])

export default __exports__